import { History } from '@thehubz/client/data-access-api';
import { AnyType } from '@thehubz/shared/model';

const infoChanged = {
  name: $localize`Name edited`,
  description: $localize`Description edited`,
  client: $localize`Client edited`,
  brand: $localize`Brand edited`,
  notes: $localize`Notes edited`,
  plannedDeletion: $localize`Planned for deletion date edited`,
  plannedDeletionUser: $localize`Planned for deletion date edited by`,
  publishStartDate: $localize`Publish start date edited`,
  publishEndDate: $localize`Publish end date edited`,
  currentVersion: $localize`Default version edited`,
  product: $localize`Product edited`,
  subcategory: $localize`Sub category edited`,
  channel: $localize`Channel edited`,
  subject: $localize`Subject edited`,
  exchange_link: $localize`Exchange link edited`,
  mainAssetMedium: $localize`Main medium edited`,
  genPreviewAssetMedium: $localize`Preview medium edited`,
  genThumbnailAssetMedium: $localize`Thumbnail medium edited`,
};

export const historyActionTypeLabels = {
  Common: {
    Item_Created: $localize`Created`,
    Item_Uploaded: $localize`Uploaded`,
    Status_Changed: $localize`Status changed`,
    Info_Changed: infoChanged,
    Item_Deleted: $localize`Deleted/archived`,
    Item_Downloaded: $localize`Downloaded`,
    Cover_Image_Changed: $localize`Cover image changed`,
    New_Version_Added: $localize`New version added`,
    New_Variant_Added: $localize`New variant/file format added`,
    Item_Shared: $localize`Shared`,
    Owner_Added: $localize`Owner added`,
    Owner_Removed: $localize`Owner removed`,
    Tag_Added: $localize`Tag added`,
    Tag_Removed: $localize`Tag removed`,
    Tag_Edited: $localize`Tag edited`,
    Tag_Deleted: $localize`Tag deleted`,
    Relation_Created: $localize`Relation created`,
    Relation_Removed: $localize`Relation removed`,
    File_Format_Deleted: $localize`File format deleted`,
    UsageRights_Added: $localize`Usage rights added`,
    UsageRights_Changed: $localize`Buyout right`,
    UsageRights_Deleted: $localize`Buyout right deleted`,
  } as { [key in History.ActionPerformedEnum]: AnyType },
  [History.EntityTypeEnum.Asset]: {
    Item_Added_To_Collection: $localize`Added to collection`,
    Item_Removed_From_Collection: $localize`Removed from collection`,
  } as { [key in History.ActionPerformedEnum]: string },
  [History.EntityTypeEnum.Collection]: {
    Item_Published: $localize`Published`,
    Item_UnPublished: $localize`Unpublished`,
    Item_Added_To_Collection: $localize`New asset added`,
    Item_Removed_From_Collection: $localize`Asset removed`,
  } as { [key in History.ActionPerformedEnum]: string },
};
